// Initiates Klaviyo subscribe on scroll — gated on tracking consent
// --------------------------------------------------
// klaviyo_subscribe.js is non-essential (sets Klaviyo cookies), so it must not load
// until the visitor can be tracked. Consent is read from Shopify's Customer Privacy
// API, which the Enzuzo cookie banner writes into. Fail-closed: never load unless the
// API confirms the visitor can be tracked.

import scriptLoader from "../utilities/scriptLoader";

let subscribeLoaded = false;

function canTrack() {
    try {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        return !!(cp && cp.userCanBeTracked());
    } catch (e) {
        return false;
    }
}

function loadSubscribe() {
    if (subscribeLoaded || !canTrack()) return;
    subscribeLoaded = true;
    new scriptLoader('klaviyo').load([
        "//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"
    ]);
}

// Ensure the Customer Privacy API is loaded before we read consent, so an
// already-consented visitor still loads even if the API wasn't ready at scroll time.
function withConsentApi(cb) {
    if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], cb);
    } else {
        cb();
    }
}

// On first scroll, load if consent already allows it; otherwise wait until the visitor
// grants consent via the banner, then load.
document.addEventListener("scroll", () => {
    withConsentApi(() => {
        if (canTrack()) {
            loadSubscribe();
        } else {
            document.addEventListener("visitorConsentCollected", loadSubscribe);
        }
    });
}, { once: true });
